"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketServiceReadyEvent = void 0;
const event_type_1 = require("../enums/event-type");
class WebsocketServiceReadyEvent {
    constructor(webSocketService) {
        this.webSocketService = webSocketService;
        this.eventType = WebsocketServiceReadyEvent.EventType;
        this.eventAggregationService = webSocketService;
        this.timestamp = new Date();
    }
}
exports.WebsocketServiceReadyEvent = WebsocketServiceReadyEvent;
WebsocketServiceReadyEvent.EventType = event_type_1.WebSocketEventType.WEBSOCKET_SERVICE_READY;
